import { render, staticRenderFns } from "./ApplicantReview.vue?vue&type=template&id=603f7274&scoped=true"
import script from "./ApplicantReview.vue?vue&type=script&lang=js"
export * from "./ApplicantReview.vue?vue&type=script&lang=js"
import style0 from "./ApplicantReview.vue?vue&type=style&index=0&id=603f7274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603f7274",
  null
  
)

export default component.exports